import { render, staticRenderFns } from "./Hours48ParamsPm25.vue?vue&type=template&id=7fd0f4fb&scoped=true&"
import script from "./Hours48ParamsPm25.vue?vue&type=script&lang=js&"
export * from "./Hours48ParamsPm25.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd0f4fb",
  null
  
)

export default component.exports